import { ENV } from '@/constants';

import { BtcLikeNetwork, NetworkNet } from '../common';

import { getSatPerVbEstimateFee } from './api';

export const DogeNetworkSettings = {
  [NetworkNet.Mainnet]: {
    bech32: '',
    pubKeyHash: 0x1e,
    scriptHash: 0x16,
    wif: 0x9e,
  },
  [NetworkNet.Testnet]: {
    bech32: '',
    pubKeyHash: 0x71,
    scriptHash: 0xc4,
    wif: 0xf1,
  },
} as const;

const DogeExplorerMap: Record<NetworkNet, string> = {
  [NetworkNet.Mainnet]: 'https://blockexplorer.one/dogecoin/mainnet',
  [NetworkNet.Testnet]: 'https://blockexplorer.one/dogecoin/testnet',
};

const isDogeNetwork = (value: string): value is NetworkNet => (Object.values(NetworkNet) as string[]).includes(value);

const mempoolApiEndpoint = (ENV['VITE_DOGE_MEMPOOL_API_ENDPOINT'] as string)
  .split('/')
  .map((slug) => (slug[0] === '$' ? (ENV[slug.slice(1)] as string) : slug))
  .join('/');

export const NETWORK: BtcLikeNetwork = {
  get Network() {
    if (!isDogeNetwork(ENV['VITE_DOGE_NETWORK'])) {
      throw new Error(
        'Incorrect value ' +
          ENV['VITE_DOGE_NETWORK'] +
          ' for variable VITE_DOGE_NETWORK. Use one of ' +
          Object.values(NetworkNet).join(', ')
      );
    }

    return ENV['VITE_DOGE_NETWORK'];
  },

  get BlockstreamApiEndpoint() {
    return (ENV['VITE_DOGE_BLOCKSTREAM_API_ENDPOINT'] as string)
      .split('/')
      .map((slug) => (slug[0] === '$' ? (ENV[slug.slice(1)] as string) : slug))
      .join('/');
  },

  get MempoolApiEndpoint() {
    return mempoolApiEndpoint;
  },

  get Settings() {
    return DogeNetworkSettings[NETWORK.Network];
  },

  get MempoolSpendingUtxoEndpoint(): string {
    return (ENV['VITE_DOGE_SPENDING_UTXO_ENDPOINT'] as string)
      .split('/')
      .map((slug) => (slug[0] === '$' ? (ENV[slug.slice(1)] as string) : slug))
      .join('/');
  },

  get ExplorerUrl() {
    const network = this.Network;

    return DogeExplorerMap[network];
  },

  get DustLimit() {
    return Number(ENV['VITE_DOGE_DUST_LIMIT']);
  },

  get FeeCorrection() {
    return BigInt(Number(import.meta.env['VITE_DOGE_FEE_CORRECTION'] || 1));
  },

  api: {
    getSatPerVbEstimateFee: () => getSatPerVbEstimateFee(mempoolApiEndpoint),
  },
};
